import { render, staticRenderFns } from "./Notifications.vue?vue&type=template&id=2b92f7a2&scoped=true&"
import script from "./Notifications.vue?vue&type=script&lang=js&"
export * from "./Notifications.vue?vue&type=script&lang=js&"
import style0 from "./Notifications.vue?vue&type=style&index=0&id=2b92f7a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b92f7a2",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NotificationsList: require('/home/bitrix/frontend/components/sidebars/NotificationsAside/NotificationsList.vue').default,Sentinel: require('/home/bitrix/frontend/components/other/Sentinel.vue').default})
